import { createFileRoute } from '@tanstack/react-router';

import { NotificationsPage } from '@/features/notifications/notifications-page';

/** The supplier portal's alerts (prototype `supplier_.notifications`): the same inbox, supplier groups. */
export const Route = createFileRoute('/_app/supplier/$orgId/notifications')({
  component: () => <NotificationsPage supplier />,
});
